import { render, staticRenderFns } from "./ShoppingCar.vue?vue&type=template&id=b10a3a12&scoped=true"
import script from "./ShoppingCar.vue?vue&type=script&lang=js"
export * from "./ShoppingCar.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCar.vue?vue&type=style&index=0&id=b10a3a12&prod&lang=scss&scoped=true"
import style1 from "./ShoppingCar.vue?vue&type=style&index=1&id=b10a3a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10a3a12",
  null
  
)

export default component.exports